import { LOAD_CURRENT_USER_INFO } from 'actions/actionTypes';
import { getCurrentUserInformation } from 'api/currentUser';
import {
  getCurrentUserInfoSuccess,
  getCurrentUserInfoFailure
} from 'actions';
import { EventTypes } from 'redux-segment';
import { get } from 'lodash';
import { apiPromise } from './apiPromise';

export const currentUser = store => next => (action) => {
  switch (action.type) {
    case LOAD_CURRENT_USER_INFO.REQUEST:
    {
      next(action);
      return apiPromise(
        store,
        action,
        getCurrentUserInformation,
        [],
        getCurrentUserInfoSuccess,
        getCurrentUserInfoFailure
      );
    }
    case LOAD_CURRENT_USER_INFO.SUCCESS: {
      // make a segment identify call
      const { meta, payload } = action;
      const { currentUser: thisUser } = payload;
      const id = get(thisUser, 'id', undefined);
      const segmentMeta = {
        analytics: [{
          eventType: EventTypes.identify,
          eventPayload: {
            userId: id,
            traits: {
              ...thisUser
            }
          }
        }]
      };
      const trackedAction = {
        ...action,
        meta: {
          ...meta,
          ...segmentMeta
        }
      };
      next(trackedAction);
      return Promise.resolve();
    }
    default:
      next(action);
      return Promise.resolve();
  }
};

export default currentUser;
